import { PropsWithChildren } from 'react';
import {
  pageTheme as basePageTheme,
  PageTheme,
  genPageTheme,
  colorVariants,
  shapes,
  createUnifiedTheme,
  createBaseThemeOptions,
  palettes,
  UnifiedThemeProvider,
  UnifiedThemeOptions,
} from '@backstage/theme';
import DarkIcon from '@material-ui/icons/Brightness2';
import LightIcon from '@material-ui/icons/WbSunny';
import { CssBaseline } from '@material-ui/core';
import { AppTheme } from '@backstage/core-plugin-api';

const defaultPageTheme = 'home';
const pageTheme: Record<string, PageTheme> = {
  ...basePageTheme,
  pipeline: genPageTheme({
    colors: colorVariants.purpleSky,
    shape: shapes.round,
  }),
};
const components: UnifiedThemeOptions['components'] = {
  BackstageDismissableBanner: {
    styleOverrides: {
      message: ({ theme }) => ({
        '& a': {
          fontWeight: 'bold',
          color: theme.palette.banner.text,
        },
      }),
    },
  },
  BackstageLifecycle: {
    styleOverrides: {
      beta: ({ theme }) => ({
        color: theme.palette.common.white,
      }),
    },
  },
};

export default [
  {
    id: 'appfolio-light',
    title: 'Light Theme',
    variant: 'light',
    icon: <LightIcon />,
    Provider: ({ children }: PropsWithChildren) => (
      <UnifiedThemeProvider
        theme={createUnifiedTheme({
          ...createBaseThemeOptions({
            palette: palettes.light,
          }),
          defaultPageTheme,
          pageTheme,
          components,
        })}
      >
        <CssBaseline>{children}</CssBaseline>
      </UnifiedThemeProvider>
    ),
  },
  {
    id: 'appfolio-dark',
    title: 'Dark Theme',
    variant: 'dark',
    icon: <DarkIcon />,
    Provider: ({ children }: PropsWithChildren) => (
      <UnifiedThemeProvider
        theme={createUnifiedTheme({
          ...createBaseThemeOptions({
            palette: palettes.dark,
          }),
          defaultPageTheme,
          pageTheme,
          components,
        })}
      >
        <CssBaseline>{children}</CssBaseline>
      </UnifiedThemeProvider>
    ),
  },
] satisfies AppTheme[];
